import { awaitWrap, OK } from '@/common';
import { qryExportBillTaskStatus } from '@/api/thirdParty';
import { message } from 'ant-design-vue';
export function useTimer() {
  const timer = ref(null);
  const getExportFile = async taskId => {
    const [err, data] = await awaitWrap(qryExportBillTaskStatus({
      taskId
    }));
    if (data && data.code === OK) {
      var _data$data, _data$data2;
      if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.status) === '1') {
        // 下载方式调整 2025-08-04
        const path = data.data.url;
        const fileName = path.split('/').pop();
        window.open((process.env.VUE_APP_DOMAIN || '') + process.env.VUE_APP_SERVENAME + '/bill/download?fileName=' + fileName, '_blank');
        timer.value && clearInterval(timer.value);
        timer.value = null;
      }
      if (((_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.status) === '2') {
        message.error('导出失败');
        timer.value && clearInterval(timer.value);
        timer.value = null;
      }
    }
    if (err) {}
  };
  return {
    timer,
    getExportFile
  };
}